/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {buildAndPrepareUserOp} from '../api'

export const useMutationBuildAndPrepareUserOp = createReactQueryMutationHook('buildAndPrepareUserOp', buildAndPrepareUserOp)
